<form [formGroup]="forgotForm" (ngSubmit)="onClickSendRecoveryEmail()">
  <div class="fwc-container">
    <div class="fwc-row fwc-row-bm">
      <div class="fwc-input">
        <label for="Email">Email</label>
        <input formControlName="email" name="Email" id="Email" type="text"
          attr.aria-invalid="{{submitted && form.email.errors ? true : false}}" required/>
        @if (submitted && form.email.hasError('email') && !form.email.hasError('required')) {
          <span role="alert" class="fwc-inline-icon fwc-icon-delete" id="email_error">Please enter a valid email address.</span>
        }
        @if (submitted && form.email.hasError('required')) {
          <span role="alert" class="fwc-inline-icon fwc-icon-delete" id="email_error">Please enter your email address to continue</span>
        }
      </div>
    </div>
    <div class="fwc-row fwc-row-bm">
      <button type="submit" class="fwc-btn fwc-btn-primary btn_SendMail" [disabled]="displaySpinner">{{content.button}}</button>
    </div>
  </div>
</form>

@if (displaySpinner) {
  <div class="ant-ui-widget-overlay"></div>
  <div class="ant-ajax-loader">
    <fwc-preloader></fwc-preloader>
  </div>
}